export const appendix1 = [
  {
    author: {
      en: "<strong>李頴詩、龔永珩</strong> （2017）",
      zh: "<strong>李頴詩、龔永珩</strong> （2017）",
    },
    title: {
      en: "澳門文化節慶旅遊的發展與推廣",
      zh: "澳門文化節慶旅遊的發展與推廣",
    },
    publisher: {
      en: [
        "澳門綠皮書．澳門旅遊休閒發展報告（2016-2017）",
        "郝雨凡、林廣志主編",
        "北京：社會科學文獻出版社",
      ],
      zh: [
        "澳門綠皮書．澳門旅遊休閒發展報告（2016-2017）",
        "郝雨凡、林廣志主編",
        "北京：社會科學文獻出版社",
      ]
    }
  },
  {
    author: {
      en: "<strong>Coimbra, D., Wong, C. U. I., Chan, C. C., & Sam, W. C.</strong> (2017).",
      zh: "<strong>Coimbra, D., Wong, C. U. I., Chan, C. C., & Sam, W. C.</strong> (2017).",
    },
    title: {
      en: "Path finding the history of Macau - Histro-interpretation of the cultural thematic routes ",
      zh: "Path finding the history of Macau - Histro-interpretation of the cultural thematic routes ",
    },
    publisher: {
      en: [
        "(eds.) Macao: Institute for Tourism Studies.",
      ],
      zh: [
        "(eds.) Macao: Institute for Tourism Studies.",
      ]
    }
  },
  {
    author: {
      en: "<strong>Wu, C.W.</strong>, & Tso. K. F. (2017)",
      zh: "<strong>Wu, C.W.</strong>, & Tso. K. F. (2017)",
    },
    title: {
      en: "Good practices and considerations in conducting email survey for fashion retail industry",
      zh: "Good practices and considerations in conducting email survey for fashion retail industry",
    },
    publisher: {
      en: [
        "In: Chow PS., Chiu CH., C. Y. Yip A., K. Y. Tang A. (eds) Contemporary Case Studies on Fashion Production, Marketing and Operations. Springer Series in Fashion Business. Springer, Singapore",
      ],
      zh: [
        "In: Chow PS., Chiu CH., C. Y. Yip A., K. Y. Tang A. (eds) Contemporary Case Studies on Fashion Production, Marketing and Operations. Springer Series in Fashion Business. Springer, Singapore",
      ]
    }
  },
  {
    author: {
      en: "<strong>李穎詩</strong>（2018）",
      zh: "<strong>李穎詩</strong>（2018）",
    },
    title: {
      en: "澳門藝術節慶與旅遊休閒的融合發展：現狀、特徵與趨勢",
      zh: "澳門藝術節慶與旅遊休閒的融合發展：現狀、特徵與趨勢",
    },
    publisher: {
      en: [
        "澳門綠皮書．澳門旅遊休閒發展報告（2017-2018）",
        "林廣志、郝雨凡主編，趙殿紅、趙偉兵副主編",
        "北京：社會科學文獻出版社",
      ],
      zh: [
        "澳門綠皮書．澳門旅遊休閒發展報告（2017-2018）",
        "林廣志、郝雨凡主編，趙殿紅、趙偉兵副主編",
        "北京：社會科學文獻出版社",
      ]
    }
  },
  {
    author: {
      en: "<strong>呂劍英、龔永珩</strong>（2018）",
      zh: "<strong>呂劍英、龔永珩</strong>（2018）",
    },
    title: {
      en: "澳門博彩企業非博彩元素的發展現狀、效益與趨勢",
      zh: "澳門博彩企業非博彩元素的發展現狀、效益與趨勢",
    },
    publisher: {
      en: [
        "澳門綠皮書．澳門旅遊休閒發展報告（2017-2018）",
        "林廣志、郝雨凡主編，趙殿紅、趙偉兵副主編",
        "北京：社會科學文獻出版社",
      ],
      zh: [
        "澳門綠皮書．澳門旅遊休閒發展報告（2017-2018）",
        "林廣志、郝雨凡主編，趙殿紅、趙偉兵副主編",
        "北京：社會科學文獻出版社",
      ]
    }
  },
  {
    author: {
      en: "<strong>黃竹君</strong>（2018）",
      zh: "<strong>黃竹君</strong>（2018）",
    },
    title: {
      en: "澳門高等院校旅遊教育的基礎、特色與趨勢",
      zh: "澳門高等院校旅遊教育的基礎、特色與趨勢",
    },
    publisher: {
      en: [
        "澳門綠皮書．澳門旅遊休閒發展報告（2017-2018）",
        "林廣志、郝雨凡主編，趙殿紅、趙偉兵副主編",
        "北京：社會科學文獻出版社",
      ],
      zh: [
        "澳門綠皮書．澳門旅遊休閒發展報告（2017-2018）",
        "林廣志、郝雨凡主編，趙殿紅、趙偉兵副主編",
        "北京：社會科學文獻出版社",
      ]
    }
  },
  {
    author: {
      en: "<strong>黃竹君</strong>（2018）",
      zh: "<strong>黃竹君</strong>（2018）",
    },
    title: {
      en: "發揮澳門旅遊教育優勢　助力“一帶一路”建設",
      zh: "發揮澳門旅遊教育優勢　助力“一帶一路”建設",
    },
    publisher: {
      en: [
        "“一帶一路”與澳門發展",
        "澳門特別行政區政策研究室、澳門基金會、思路智庫主編",
        "澳門：澳門基金會；北京：社會科學文獻出版社",
      ],
      zh: [
        "“一帶一路”與澳門發展",
        "澳門特別行政區政策研究室、澳門基金會、思路智庫主編",
        "澳門：澳門基金會；北京：社會科學文獻出版社",
      ]
    }
  },
  {
    author: {
      en: "<strong>Abdel Fattah, A., & Eddy-U, M. E.</strong> (2018)",
      zh: "<strong>Abdel Fattah, A., & Eddy-U, M. E.</strong> (2018)",
    },
    title: {
      en: "Existential authenticity in Bedouin tourism: International tourists’ perspectives and appreciation of bedouin tourism attractions in Egypt ",
      zh: "Existential authenticity in Bedouin tourism: International tourists’ perspectives and appreciation of bedouin tourism attractions in Egypt ",
    },
    publisher: {
      en: [
        "In T. Lukic and A. Terzic (Eds.), Ethnic Groups at the beginning of the 21<sup>st</sup> Century. University of Novi Sad Faculty of Sciences, Department for geography, tourism and hotel management",
      ],
      zh: [
        "In T. Lukic and A. Terzic (Eds.), Ethnic Groups at the beginning of the 21<sup>st</sup> Century. University of Novi Sad Faculty of Sciences, Department for geography, tourism and hotel management",
      ]
    }
  },
  {
    author: {
      en: "<strong>Choi, S.</strong> & Kim, J. (2018)",
      zh: "<strong>Choi, S.</strong> & Kim, J. (2018)",
    },
    title: {
      en: "Students’ perception and experience of international educational tourism",
      zh: "Students’ perception and experience of international educational tourism",
    },
    publisher: {
      en: [
        "In Khoo-Lattimore, C. and Yang, E. (eds.) Asian youth tourism-Perspectives on Asian Tourism series (chapter 3), Springer",
      ],
      zh: [
        "In Khoo-Lattimore, C. and Yang, E. (eds.) Asian youth tourism-Perspectives on Asian Tourism series (chapter 3), Springer",
      ]
    }
  },
  {
    author: {
      en: "<strong>Gibson M.</strong> (2018)",
      zh: "<strong>Gibson M.</strong> (2018)",
    },
    title: {
      en: "Food Science and the Culinary Arts",
      zh: "Food Science and the Culinary Arts",
    },
    publisher: {
      en: [
        "London-USA, Academic Press (Elsevier), 506pp.",
      ],
      zh: [
        "London-USA, Academic Press (Elsevier), 506pp.",
      ]
    }
  },
  {
    author: {
      en: "<strong>Guan, J.</strong> & Noronha, C. (2018)",
      zh: "<strong>Guan, J.</strong> & Noronha, C. (2018)",
    },
    title: {
      en: "Corporate social responsibility reporting in China: Evolution, drivers and prospects",
      zh: "Corporate social responsibility reporting in China: Evolution, drivers and prospects",
    },
    publisher: {
      en: [
        "Routledge (Taylor & Francis Group), London & New York",
      ],
      zh: [
        "Routledge (Taylor & Francis Group), London & New York",
      ]
    }
  },
  {
    author: {
      en: "Fong, L. H. N., Chan, I. C. C., Law, R., & <strong>Ly, T. P.</strong> (2018)",
      zh: "Fong, L. H. N., Chan, I. C. C., Law, R., & <strong>Ly, T. P.</strong> (2018)",
    },
    title: {
      en: "The mechanism that links the implicit theories of intelligence and continuance of information technology: Evidence from the use of mobile apps to make hotel reservations",
      zh: "The mechanism that links the implicit theories of intelligence and continuance of information technology: Evidence from the use of mobile apps to make hotel reservations",
    },
    publisher: {
      en: [
        "In Stangl, B. & Pesonen, J. (Eds.), Information and Communication Technologies in Tourism 2018 (pp. 323-335). Cham, Switzerland: Springer International Publishing",
      ],
      zh: [
        "In Stangl, B. & Pesonen, J. (Eds.), Information and Communication Technologies in Tourism 2018 (pp. 323-335). Cham, Switzerland: Springer International Publishing",
      ]
    }
  },
]

export const appendix2 = [
  {
    author: {
      en: "<strong>Lam, C.C., & Im, U.L.</strong> (2018)",
      zh: "<strong>Lam, C.C., & Im, U.L.</strong> (2018)",
    },
    title: {
      en: "Tourist Floods, GDP Rockets, the Government Intervenes: Smoking Ordinance and Its Implementation",
      zh: "Tourist Floods, GDP Rockets, the Government Intervenes: Smoking Ordinance and Its Implementation",
    },
    publisher: {
      en: [
        "Journal of Policy Research in Tourism, Leisure and Events",
        "DOI:10.1080/19407963.2018.151608",
      ],
      zh: [
        "Journal of Policy Research in Tourism, Leisure and Events DOI:10.1080/19407963.2018.151608",
      ]
    }
  },
  {
    author: {
      en: "<strong>Lam, C.C.</strong>, & Hu, X.X. (2018)",
      zh: "<strong>Lam, C.C.</strong>, & Hu, X.X. (2018)",
    },
    title: {
      en: "Parenting Stress and its Associated Factors among Parents Working in Hospitality and Services Industries of Macau",
      zh: "Parenting Stress and its Associated Factors among Parents Working in Hospitality and Services Industries of Macau",
    },
    publisher: {
      en: [
        "Journal of Tourism & Hospitality, 7(3), pp 1-6. DOI: 10.4172/2167-0269.1000362",
      ],
      zh: [
        "Journal of Tourism & Hospitality, 7(3), pp 1-6. DOI: 10.4172/2167-0269.1000362",
      ]
    }
  },
  {
    author: {
      en: "Wang, J. F., Lin, Y. C., <strong>Kuo, C.F.</strong>, & Weng, S. J. (2017)",
      zh: "Wang, J. F., Lin, Y. C., <strong>Kuo, C.F.</strong>, & Weng, S. J. (2017)",
    },
    title: {
      en: "Cherry-picking restaurant reservation customers",
      zh: "Cherry-picking restaurant reservation customers",
    },
    publisher: {
      en: [
        "Asia Pacific Management Review 22: 113-121",
      ],
      zh: [
        "Asia Pacific Management Review 22: 113-121",
      ]
    }
  },
  {
    author: {
      en: "Weng, S. J., Gotcher, D., & <strong>Kuo, C. F.</strong> (2017)",
      zh: "Weng, S. J., Gotcher, D., & <strong>Kuo, C. F.</strong> (2017)",
    },
    title: {
      en: "Lining up for quick service-The business impact of express lines on fast-food restaurant operations",
      zh: "Lining up for quick service-The business impact of express lines on fast-food restaurant operations",
    },
    publisher: {
      en: [
        "Journal of Foodservice Business Research 20 (1): 65-81",
      ],
      zh: [
        "Journal of Foodservice Business Research 20 (1): 65-81",
      ]
    }
  },
  {
    author: {
      en: "<strong>Kong, W. H.,</strong> & <strong>Loi, K. I.</strong> (2017)",
      zh: "<strong>Kong, W. H.,</strong> & <strong>Loi, K. I.</strong> (2017)",
    },
    title: {
      en: "Holiday taking for disabled people and their families: An exploration of the research for vision impairment and blind travellers",
      zh: "Holiday taking for disabled people and their families: An exploration of the research for vision impairment and blind travellers",
    },
    publisher: {
      en: [
        "Journal of Hospitality and Tourism Management, 32, pp99-107",
      ],
      zh: [
        "Journal of Hospitality and Tourism Management, 32, pp99-107",
      ]
    }
  },
  {
    author: {
      en: "Lin, P., Kim, Y., Qiu, H., & <strong>Ren, L.</strong> (2017)",
      zh: "Lin, P., Kim, Y., Qiu, H., & <strong>Ren, L.</strong> (2017)",
    },
    title: {
      en: "Experiential learning in hospitality education through a service learning project",
      zh: "Experiential learning in hospitality education through a service learning project",
    },
    publisher: {
      en: [
        "Journal of Hospitality & Tourism Education 29:2, 71 - 81",
      ],
      zh: [
        "Journal of Hospitality & Tourism Education 29:2, 71 - 81",
      ]
    }
  },
  {
    author: {
      en: "<strong>Sou P.U., Vinnicombe, T.</strong>, & Leung, T., (2017)",
      zh: "<strong>Sou P.U., Vinnicombe, T.</strong>, & Leung, T., (2017)",
    },
    title: {
      en: "Performing arts and destination image: The case of Macao ",
      zh: "Performing arts and destination image: The case of Macao ",
    },
    publisher: {
      en: [
        "International Journal of Culture, Tourism and Hospitality Research, Vol. 10 Issue: 1, pp.91-104, https://www.emeraldinsight.com/doi/full/10.1108/IJCTHR-01-2015-0004",
      ],
      zh: [
        "International Journal of Culture, Tourism and Hospitality Research, Vol. 10 Issue: 1, pp.91-104, https://www.emeraldinsight.com/doi/full/10.1108/IJCTHR-01-2015-0004",
      ]
    }
  },
  {
    author: {
      en: "<strong>Yang, F. X.</strong>, Zhang, R. Q. & Zhu, K. (2017)",
      zh: "<strong>Yang, F. X.</strong>, Zhang, R. Q. & Zhu, K. (2017)",
    },
    title: {
      en: "Should purchasing activities be outsourced along with production?",
      zh: "Should purchasing activities be outsourced along with production?",
    },
    publisher: {
      en: [
        "European Journal of Operational Research, 257 (2), 468-482",
      ],
      zh: [
        "European Journal of Operational Research, 257 (2), 468-482",
      ]
    }
  },
  {
    author: {
      en: "<strong>Yang, F. X.</strong> & <strong>Tan, S. X.</strong> (2017)",
      zh: "<strong>Yang, F. X.</strong> & <strong>Tan, S. X.</strong> (2017)",
    },
    title: {
      en: "Event innovation induced corporate branding",
      zh: "Event innovation induced corporate branding",
    },
    publisher: {
      en: [
        "International Journal of Contemporary Hospitality Management, 29 (3), 862-882",
      ],
      zh: [
        "International Journal of Contemporary Hospitality Management, 29 (3), 862-882",
      ]
    }
  },
  {
    author: {
      en: "<strong>Yang, F. X.</strong> (2017)",
      zh: "<strong>Yang, F. X.</strong> (2017)",
    },
    title: {
      en: "Effects of restaurant satisfaction and knowledge sharing motivation on eWOM intentions: The moderating role of technology acceptance factors",
      zh: "Effects of restaurant satisfaction and knowledge sharing motivation on eWOM intentions: The moderating role of technology acceptance factors",
    },
    publisher: {
      en: [
        "Journal of Hospitality & Tourism Research, 41 (1), 93-127. (ABDC, Tourism, A)",
      ],
      zh: [
        "Journal of Hospitality & Tourism Research, 41 (1), 93-127. (ABDC, Tourism, A)",
      ]
    }
  },
  {
    author: {
      en: "<strong>Basnyat, S</strong> (2018)",
      zh: "<strong>Basnyat, S</strong> (2018)",
    },
    title: {
      en: "Co-construction in the study of the trade union movements in the Nepalese tourism industry using a grounded theory approach",
      zh: "Co-construction in the study of the trade union movements in the Nepalese tourism industry using a grounded theory approach",
    },
    publisher: {
      en: [
        "In P. Mura & C. Lattimore (Eds.), Asian Qualitative Research in Tourism: Ontologies, Epistemologies, Methodologies, and Methods (pp.221-238). Singapore: Springer",
      ],
      zh: [
        "In P. Mura & C. Lattimore (Eds.), Asian Qualitative Research in Tourism: Ontologies, Epistemologies, Methodologies, and Methods (pp.221-238). Singapore: Springer",
      ]
    }
  },
  {
    author: {
      en: "<strong>Choi, S.</strong> & Fu, X. (2018)",
      zh: "<strong>Choi, S.</strong> & Fu, X. (2018)",
    },
    title: {
      en: "Hosting friends and family as a sojourner in a tourism destination",
      zh: "Hosting friends and family as a sojourner in a tourism destination",
    },
    publisher: {
      en: [
        "Tourism Management, 67, 47-58. DOI:10.1016/j.tourman.2017.12.023",
      ],
      zh: [
        "Tourism Management, 67, 47-58. DOI:10.1016/j.tourman.2017.12.023",
      ]
    }
  },
  {
    author: {
      en: "<strong>Choi, S.</strong> & Wong, C. U. I. (2018)",
      zh: "<strong>Choi, S.</strong> & Wong, C. U. I. (2018)",
    },
    title: {
      en: "Toponymy, place name conversion and wayfinding: South Korean independent tourists in Macau",
      zh: "Toponymy, place name conversion and wayfinding: South Korean independent tourists in Macau",
    },
    publisher: {
      en: [
        "Tourism Management Perspectives, 25, 13-22. DOI:10.1016/j.tmp.2017.10.007 ",
      ],
      zh: [
        "Tourism Management Perspectives, 25, 13-22. DOI:10.1016/j.tmp.2017.10.007 ",
      ]
    }
  },
  {
    author: {
      en: "<strong>Choi, S.</strong> & Cai, L. A. (2018)",
      zh: "<strong>Choi, S.</strong> & Cai, L. A. (2018)",
    },
    title: {
      en: "The role of relationship quality in integrated destination marketing",
      zh: "The role of relationship quality in integrated destination marketing",
    },
    publisher: {
      en: [
        "Journal of Travel & Tourism Marketing, 35(5), 541-552. DOI:10.1080/10548408.2017.1403999 ",
      ],
      zh: [
        "Journal of Travel & Tourism Marketing, 35(5), 541-552. DOI:10.1080/10548408.2017.1403999 ",
      ]
    }
  },
  {
    author: {
      en: "Noronha, C., <strong>Guan,J.</strong>, & Fan, J. (2018)",
      zh: "Noronha, C., <strong>Guan,J.</strong>, & Fan, J. (2018)",
    },
    title: {
      en: "Firm value and social contribution with the interaction of corporate governance: social contribution value per share",
      zh: "Firm value and social contribution with the interaction of corporate governance: social contribution value per share",
    },
    publisher: {
      en: [
        "Sustainability Accounting, Management and Policy Journal, 9, (2), 165-200",
      ],
      zh: [
        "Sustainability Accounting, Management and Policy Journal, 9, (2), 165-200",
      ]
    }
  },
  {
    author: {
      en: "<strong>Ngan, H. F. B., Ren, L.</strong>, & <strong>O’Bree, G.</strong> (2018)",
      zh: "<strong>Ngan, H. F. B., Ren, L.</strong>, & <strong>O’Bree, G.</strong> (2018)",
    },
    title: {
      en: "Lucky 8-ending - A case study on managerial price-ending beliefs in Macao",
      zh: "Lucky 8-ending - A case study on managerial price-ending beliefs in Macao",
    },
    publisher: {
      en: [
        "Journal of Hospitality and Tourism Management, <br/>36: 22-30",
      ],
      zh: [
        "Journal of Hospitality and Tourism Management, <br/>36: 22-30",
      ]
    }
  },
]

export const appendix3 = [
  {
    author: {
      en: "<strong>Bale, R. R.</strong>",
      zh: "<strong>Bale, R. R.</strong>",
    },
    paper: {
      en: "La Délinquance Idéologique: Sony Labou Tansi and the political love story of Romeo and Juliet",
      zh: "La Délinquance Idéologique: Sony Labou Tansi and the political love story of Romeo and Juliet",
    },
    conference: {
      en: "The International Shakspeare Conference at Cheongju (Korea) 2017",
      zh: "The International Shakspeare Conference at Cheongju (Korea) 2017",
    },
    placeAndDate: {
      en: 'Cheongju, South Korea, 2017',
      zh: 'Cheongju, South Korea, 2017',
    },
  },
  {
    author: {
      en: "<strong>Choi, S.</strong>",
      zh: "<strong>Choi, S.</strong>",
    },
    paper: {
      en: "Expatriates’ sense of place and local information forwarding ",
      zh: "Expatriates’ sense of place and local information forwarding ",
    },
    conference: {
      en: "2017 EuroCHRIE Conference",
      zh: "2017 EuroCHRIE Conference",
    },
    placeAndDate: {
      en: 'Nairobi, Kenya, 2017',
      zh: 'Nairobi, Kenya, 2017',
    },
  },
  {
    author: {
      en: "<strong>Choi, S.</strong>",
      zh: "<strong>Choi, S.</strong>",
    },
    paper: {
      en: "Migrant worker’s self-recognition as a tourism informant: An exploratory study of Filipinos in Macao and Hong Kong",
      zh: "Migrant worker’s self-recognition as a tourism informant: An exploratory study of Filipinos in Macao and Hong Kong",
    },
    conference: {
      en: "TTRA APac Annual Conference",
      zh: "TTRA APac Annual Conference",
    },
    placeAndDate: {
      en: 'Hong Kong, SAR, 2017',
      zh: 'Hong Kong, SAR, 2017',
    },
  },
  {
    author: {
      en: "<strong>Choi, S.</strong>, <strong>Couto, U. S.</strong>, & <strong>Imon, S. S.</strong>",
      zh: "<strong>Choi, S.</strong>, <strong>Couto, U. S.</strong>, & <strong>Imon, S. S.</strong>",
    },
    paper: {
      en: "Participating and non-participating residents’ perceptions and attitudes towards Macao’s Drunken Dragon Festival",
      zh: "Participating and non-participating residents’ perceptions and attitudes towards Macao’s Drunken Dragon Festival",
    },
    conference: {
      en: "4<sup>th</sup> International Conference on Events (ICE) 2017: Beyond the Waves",
      zh: "4<sup>th</sup> International Conference on Events (ICE) 2017: Beyond the Waves",
    },
    placeAndDate: {
      en: 'Orlando, FL, USA, 2017',
      zh: 'Orlando, FL, USA, 2017',
    },
  },
  {
    author: {
      en: "<strong>Couto, U.S.</strong>, & Chan, K. L. ",
      zh: "<strong>Couto, U.S.</strong>, & Chan, K. L. ",
    },
    paper: {
      en: "Threats to safeguarding cultural festivals in Macao. Paper presented at the Beyond the Waves: The 4<sup>th</sup> International Conference on Events (ICE2017), Orlando, Florida, United States of America",
      zh: "Threats to safeguarding cultural festivals in Macao. Paper presented at the Beyond the Waves: The 4<sup>th</sup> International Conference on Events (ICE2017), Orlando, Florida, United States of America",
    },
    conference: {
      en: "4<sup>th</sup> International Conference on Events (ICE) 2017: Beyond the Waves",
      zh: "4<sup>th</sup> International Conference on Events (ICE) 2017: Beyond the Waves",
    },
    placeAndDate: {
      en: 'Orlando, FL, USA, 2017',
      zh: 'Orlando, FL, USA, 2017',
    },
  },
  {
    author: {
      en: "<strong>Couto, U. S.</strong>",
      zh: "<strong>Couto, U. S.</strong>",
    },
    paper: {
      en: "Some insights of organising ethnic festivals: the case of Portuguese diaspora in Macau",
      zh: "Some insights of organising ethnic festivals: the case of Portuguese diaspora in Macau",
    },
    conference: {
      en: "2017 ATLAS Annual Conference",
      zh: "2017 ATLAS Annual Conference",
    },
    placeAndDate: {
      en: 'Viana do Castelo, Portugal, 2017',
      zh: 'Viana do Castelo, Portugal, 2017',
    },
  },
  {
    author: {
      en: "<strong>Dioko, L. A. N.</strong>",
      zh: "<strong>Dioko, L. A. N.</strong>",
    },
    paper: {
      en: "Hosting the summer Olympics and its effect on income inequality: A preliminary assessment",
      zh: "Hosting the summer Olympics and its effect on income inequality: A preliminary assessment",
    },
    conference: {
      en: "4<sup>th</sup> International Conference on Events (ICE) 2017: Beyond the Waves",
      zh: "4<sup>th</sup> International Conference on Events (ICE) 2017: Beyond the Waves",
    },
    placeAndDate: {
      en: 'Orlando, FL, USA, 2017',
      zh: 'Orlando, FL, USA, 2017',
    },
  },
  {
    author: {
      en: "<strong>Lourenco, F.</strong>, Cheng, R., & Ossie, J.",
      zh: "<strong>Lourenco, F.</strong>, Cheng, R., & Ossie, J.",
    },
    paper: {
      en: "Sustainable entrepreneurship: opportunity identification and effectuation of young entrepreneurs",
      zh: "Sustainable entrepreneurship: opportunity identification and effectuation of young entrepreneurs",
    },
    conference: {
      en: "Institute for Small Business and Entrepreneurship 2017 Conference (ISBE 2017)",
      zh: "Institute for Small Business and Entrepreneurship 2017 Conference (ISBE 2017)",
    },
    placeAndDate: {
      en: 'Northern Ireland, U. K. ',
      zh: 'Northern Ireland, U. K. ',
    },
  },
  {
    author: {
      en: "<strong>Guan, J.</strong>, Sio, H. I., Noronha, C. & Zhang, R.",
      zh: "<strong>Guan, J.</strong>, Sio, H. I., Noronha, C. & Zhang, R.",
    },
    paper: {
      en: "Reporting on employee compensation and benefits and stakeholders’ perceptions: Evidence from hospitality and gaming industry in Macao",
      zh: "Reporting on employee compensation and benefits and stakeholders’ perceptions: Evidence from hospitality and gaming industry in Macao",
    },
    conference: {
      en: "CSEAR North-Asia Hong Kong Conference",
      zh: "CSEAR North-Asia Hong Kong Conference",
    },
    placeAndDate: {
      en: 'Hong Kong SAR, 2017 ',
      zh: 'Hong Kong SAR, 2017 ',
    },
  },
  {
    author: {
      en: "Noronha, C., Zhao, Z., <strong>Guan, J.</strong> & So, S.",
      zh: "Noronha, C., Zhao, Z., <strong>Guan, J.</strong> & So, S.",
    },
    paper: {
      en: "The relationships among corporate social responsibility, tax aggressiveness and firm value in China",
      zh: "The relationships among corporate social responsibility, tax aggressiveness and firm value in China",
    },
    conference: {
      en: "CSEAR North-Asia Hong Kong Conference",
      zh: "CSEAR North-Asia Hong Kong Conference",
    },
    placeAndDate: {
      en: 'Hong Kong SAR, 2017',
      zh: 'Hong Kong SAR, 2017',
    },
  },
  {
    author: {
      en: "Cheng, U. W., Noronha, C. & <strong>Guan, J.</strong>",
      zh: "Cheng, U. W., Noronha, C. & <strong>Guan, J.</strong>",
    },
    paper: {
      en: "Environmental disclosure in China: A comparative study between the chemical and mining Sectors",
      zh: "Environmental disclosure in China: A comparative study between the chemical and mining Sectors",
    },
    conference: {
      en: "CSEAR North-Asia Hong Kong Conference",
      zh: "CSEAR North-Asia Hong Kong Conference",
    },
    placeAndDate: {
      en: 'Hong Kong SAR, 2017',
      zh: 'Hong Kong SAR, 2017',
    },
  },
  {
    author: {
      en: "<strong>Hong, C. H.</strong>",
      zh: "<strong>Hong, C. H.</strong>",
    },
    paper: {
      en: "English teachers’ perspectives on writing feedback: Not “what is better?”, but “what is feasible?”",
      zh: "English teachers’ perspectives on writing feedback: Not “what is better?”, but “what is feasible?”",
    },
    conference: {
      en: "International Conference on ESP, new technologies and digital learning",
      zh: "International Conference on ESP, new technologies and digital learning",
    },
    placeAndDate: {
      en: 'Hong Kong SAR, 2017',
      zh: 'Hong Kong SAR, 2017',
    },
  },
  {
    author: {
      en: "<strong>Imon, S. S.</strong>",
      zh: "<strong>Imon, S. S.</strong>",
    },
    paper: {
      en: "Conflict resolution between host communities and heritage authorities: the application of selfish gene theory in heritage",
      zh: "Conflict resolution between host communities and heritage authorities: the application of selfish gene theory in heritage",
    },
    conference: {
      en: "19<sup>th</sup> ICOMOS General Assembly and Scientific Symposium 2017",
      zh: "19<sup>th</sup> ICOMOS General Assembly and Scientific Symposium 2017",
    },
    placeAndDate: {
      en: 'New Delhi, India, 2017',
      zh: 'New Delhi, India, 2017',
    },
  },
  {
    author: {
      en: "Xiao, X., <strong>Lam, C. C.</strong>, & <strong>Im, U. L.</strong>",
      zh: "Xiao, X., <strong>Lam, C. C.</strong>, & <strong>Im, U. L.</strong>",
    },
    paper: {
      en: "The impacts of travel insurance on travel decision making: From occupation perspective",
      zh: "The impacts of travel insurance on travel decision making: From occupation perspective",
    },
    conference: {
      en: "3<sup>rd</sup> Global Tourism & Hospitality Conference",
      zh: "3<sup>rd</sup> Global Tourism & Hospitality Conference",
    },
    placeAndDate: {
      en: 'Hong Kong SAR, 2017',
      zh: 'Hong Kong SAR, 2017',
    },
  },
  {
    author: {
      en: "<strong>Lam, C. C.</strong>, <strong>Im, U. L.</strong> & Xiao, X.",
      zh: "<strong>Lam, C. C.</strong>, <strong>Im, U. L.</strong> & Xiao, X.",
    },
    paper: {
      en: "The role of sensation seeking styles on travel risk perception and the need for travel insurance ",
      zh: "The role of sensation seeking styles on travel risk perception and the need for travel insurance ",
    },
    conference: {
      en: "35<sup>th</sup> EuroCHRIE 2017 Conference",
      zh: "35<sup>th</sup> EuroCHRIE 2017 Conference",
    },
    placeAndDate: {
      en: 'Nairobi, Kenya, 2017',
      zh: 'Nairobi, Kenya, 2017',
    },
  },
  {
    author: {
      en: "<strong>Lei, W. S.</strong>",
      zh: "<strong>Lei, W. S.</strong>",
    },
    paper: {
      en: "Hotel strategy response upon gaming market liberalization: A case study of Macao - the world gaming capital",
      zh: "Hotel strategy response upon gaming market liberalization: A case study of Macao - the world gaming capital",
    },
    conference: {
      en: "35<sup>th</sup> EuroCHRIE 2017 Conference",
      zh: "35<sup>th</sup> EuroCHRIE 2017 Conference",
    },
    placeAndDate: {
      en: 'Nairobi, Kenya, 2017',
      zh: 'Nairobi, Kenya, 2017',
    },
  },
  {
    author: {
      en: "<strong>Loi, K. I.</strong>, <strong>Lei, W. S.</strong>, & <strong>Lourenco, F.</strong>",
      zh: "<strong>Loi, K. I.</strong>, <strong>Lei, W. S.</strong>, & <strong>Lourenco, F.</strong>",
    },
    paper: {
      en: "To leave or not to leave? A myth of the employment market in the casino industry in Macao ",
      zh: "To leave or not to leave? A myth of the employment market in the casino industry in Macao ",
    },
    conference: {
      en: "35<sup>th</sup> EuroCHRIE 2017 Conference",
      zh: "35<sup>th</sup> EuroCHRIE 2017 Conference",
    },
    placeAndDate: {
      en: 'Nairobi, Kenya, 2017',
      zh: 'Nairobi, Kenya, 2017',
    },
  },
  {
    author: {
      en: "<strong>Malungu, L. B.</strong>",
      zh: "<strong>Malungu, L. B.</strong>",
    },
    paper: {
      en: "Developing leaders for a collaborative workforce: The challenge for event management training in higher education",
      zh: "Developing leaders for a collaborative workforce: The challenge for event management training in higher education",
    },
    conference: {
      en: "4<sup>th</sup> International Conference on Events (ICE) 2017: Beyond the Waves",
      zh: "4<sup>th</sup> International Conference on Events (ICE) 2017: Beyond the Waves",
    },
    placeAndDate: {
      en: 'Orlando, FL, USA, 2017',
      zh: 'Orlando, FL, USA, 2017',
    },
  },
  {
    author: {
      en: "<strong>Ngan, H. F. B.</strong>",
      zh: "<strong>Ngan, H. F. B.</strong>",
    },
    paper: {
      en: "The effectiveness of 8-ending prices",
      zh: "The effectiveness of 8-ending prices",
    },
    conference: {
      en: "31<sup>st</sup> Annual Australian and New Zealand Academy of Management (ANZAM) Conference",
      zh: "31<sup>st</sup> Annual Australian and New Zealand Academy of Management (ANZAM) Conference",
    },
    placeAndDate: {
      en: 'Melbourne, Australia, 2017',
      zh: 'Melbourne, Australia, 2017',
    },
  },
  {
    author: {
      en: "<strong>Peralta, R. L.</strong>",
      zh: "<strong>Peralta, R. L.</strong>",
    },
    paper: {
      en: "Using online reviews to enhance academic writing: implications on ESP pedagogy",
      zh: "Using online reviews to enhance academic writing: implications on ESP pedagogy",
    },
    conference: {
      en: "International Conference on ESP, new technologies and digital learning",
      zh: "International Conference on ESP, new technologies and digital learning",
    },
    placeAndDate: {
      en: 'Hong Kong SAR, 2017',
      zh: 'Hong Kong SAR, 2017',
    },
  },
  {
    author: {
      en: "<strong>Tan, S. X.</strong> & <strong>Wu, C.W.</strong>",
      zh: "<strong>Tan, S. X.</strong> & <strong>Wu, C.W.</strong>",
    },
    paper: {
      en: "An official website’s role for international convention centers in the digital era",
      zh: "An official website’s role for international convention centers in the digital era",
    },
    conference: {
      en: "4<sup>th</sup> International Conference on Events (ICE) 2017: Beyond the Waves",
      zh: "4<sup>th</sup> International Conference on Events (ICE) 2017: Beyond the Waves",
    },
    placeAndDate: {
      en: 'Orlando, FL, USA, 2017',
      zh: 'Orlando, FL, USA, 2017',
    },
  },
  {
    author: {
      en: "Hui, T., Liao, Y., <strong>Wu, C. W.</strong>, & Lee, Y. P.",
      zh: "Hui, T., Liao, Y., <strong>Wu, C. W.</strong>, & Lee, Y. P.",
    },
    paper: {
      en: "The mediating role of idiosyncratic deals on the relationships between coaching and organizational citizenship behaviour",
      zh: "The mediating role of idiosyncratic deals on the relationships between coaching and organizational citizenship behaviour",
    },
    conference: {
      en: "31<sup>st</sup> Annual Australian and New Zealand Academy of Management (ANZAM) Conference",
      zh: "31<sup>st</sup> Annual Australian and New Zealand Academy of Management (ANZAM) Conference",
    },
    placeAndDate: {
      en: 'Melbourne, Australia, 2017',
      zh: 'Melbourne, Australia, 2017',
    },
  },
  {
    author: {
      en: "<strong>Basnyat, S.</strong>",
      zh: "<strong>Basnyat, S.</strong>",
    },
    paper: {
      en: "How Does Regulatory Environment Affect Trade Union Movement in the Tourism Industry?",
      zh: "How Does Regulatory Environment Affect Trade Union Movement in the Tourism Industry?",
    },
    conference: {
      en: "24<sup>th</sup> Asia Pacific Tourism Association Annual Conference",
      zh: "24<sup>th</sup> Asia Pacific Tourism Association Annual Conference",
    },
    placeAndDate: {
      en: 'Mactan (Cebu), The Philippines, 2018',
      zh: 'Mactan (Cebu), The Philippines, 2018',
    },
  },
  {
    author: {
      en: "<strong>Choi, S.</strong>, Choe, Y., Choi, S., Li, H., & Lao, H.",
      zh: "<strong>Choi, S.</strong>, Choe, Y., Choi, S., Li, H., & Lao, H.",
    },
    paper: {
      en: "Identity, intended image, construed image, and perceived image: A Case of Macao",
      zh: "Identity, intended image, construed image, and perceived image: A Case of Macao",
    },
    conference: {
      en: "KAHTEA Conference",
      zh: "KAHTEA Conference",
    },
    placeAndDate: {
      en: 'Las Vegas, Nevada, USA, 2018',
      zh: 'Las Vegas, Nevada, USA, 2018',
    },
  },
  {
    author: {
      en: "<strong>Choi, S.</strong>, Yang, E. C. L., & Tabari, S. ",
      zh: "<strong>Choi, S.</strong>, Yang, E. C. L., & Tabari, S. ",
    },
    paper: {
      en: "Solo dining in Macao’s Chinese restaurant",
      zh: "Solo dining in Macao’s Chinese restaurant",
    },
    conference: {
      en: "24<sup>th</sup> Asia Pacific Tourism Association Annual Conference",
      zh: "24<sup>th</sup> Asia Pacific Tourism Association Annual Conference",
    },
    placeAndDate: {
      en: 'Mactan (Cebu), The Philippines, 2018',
      zh: 'Mactan (Cebu), The Philippines, 2018',
    },
  },
  {
    author: {
      en: "<strong>Eddy-U, M. E.</strong>",
      zh: "<strong>Eddy-U, M. E.</strong>",
    },
    paper: {
      en: "Changes in EFL learning motivation after entering English-medium higher education",
      zh: "Changes in EFL learning motivation after entering English-medium higher education",
    },
    conference: {
      en: "The 16<sup>th</sup> TEFL International Conference and The 6<sup>th</sup> Hong Kong Association for Applied Linguistics Conference and The 1<sup>st</sup> Macau Association for Applied Linguistics Conference",
      zh: "The 16<sup>th</sup> TEFL International Conference and The 6<sup>th</sup> Hong Kong Association for Applied Linguistics Conference and The 1<sup>st</sup> Macau Association for Applied Linguistics Conference",
    },
    placeAndDate: {
      en: 'Macao SAR, 2018',
      zh: 'Macao SAR, 2018',
    },
  },
  {
    author: {
      en: "<strong>Gong, J.</strong>, Haw, I. & Ho, S.M.",
      zh: "<strong>Gong, J.</strong>, Haw, I. & Ho, S.M.",
    },
    paper: {
      en: "When does the market overprice or underprice analyst forecast? A comparison of market expectations with consensus earnings forecasts ",
      zh: "When does the market overprice or underprice analyst forecast? A comparison of market expectations with consensus earnings forecasts ",
    },
    conference: {
      en: "2018 American Accounting Association Annual Meeting",
      zh: "2018 American Accounting Association Annual Meeting",
    },
    placeAndDate: {
      en: 'Washington DC, US, 2018',
      zh: 'Washington DC, US, 2018',
    },
  },
  {
    author: {
      en: "<strong>Leong, I. K.</strong>, & <strong>Li Z.</strong>",
      zh: "<strong>Leong, I. K.</strong>, & <strong>Li Z.</strong>",
    },
    paper: {
      en: "Comparing the impact of distance decay and cultural distance on tourists from short haul and long haul source markets",
      zh: "Comparing the impact of distance decay and cultural distance on tourists from short haul and long haul source markets",
    },
    conference: {
      en: "Asian Forum on Business Education International Conference (The 21<sup>st</sup> AFBE 2018)",
      zh: "Asian Forum on Business Education International Conference (The 21<sup>st</sup> AFBE 2018)",
    },
    placeAndDate: {
      en: 'Phuket, Thailand, 2018',
      zh: 'Phuket, Thailand, 2018',
    },
  },
  {
    author: {
      en: "<strong>Li, X.</strong>",
      zh: "<strong>Li, X.</strong>",
    },
    paper: {
      en: "The Greening of events: A replication and extension of Mair and Jago model",
      zh: "The Greening of events: A replication and extension of Mair and Jago model",
    },
    conference: {
      en: "CAUTHE 2018",
      zh: "CAUTHE 2018",
    },
    placeAndDate: {
      en: 'Newcastle, Australia, 2018',
      zh: 'Newcastle, Australia, 2018',
    },
  },
  {
    author: {
      en: "<strong>Lourenco, F.</strong>, & Morais, F. ",
      zh: "<strong>Lourenco, F.</strong>, & Morais, F. ",
    },
    paper: {
      en: "Teaching sustainability: Bring out the evil within to teach us a lesson",
      zh: "Teaching sustainability: Bring out the evil within to teach us a lesson",
    },
    conference: {
      en: "CAUTHE 2018",
      zh: "CAUTHE 2018",
    },
    placeAndDate: {
      en: 'Newcastle, Australia, 2018',
      zh: 'Newcastle, Australia, 2018',
    },
  },
  {
    author: {
      en: "<strong>Ly, T. P.</strong>, & Fong, L. H. N. ",
      zh: "<strong>Ly, T. P.</strong>, & Fong, L. H. N. ",
    },
    paper: {
      en: "What factors drive tourists to visit Museums: The role of implicit personality belief",
      zh: "What factors drive tourists to visit Museums: The role of implicit personality belief",
    },
    conference: {
      en: "24<sup>th</sup> Asia Pacific Tourism Association (APTA) Annual Conference",
      zh: "24<sup>th</sup> Asia Pacific Tourism Association (APTA) Annual Conference",
    },
    placeAndDate: {
      en: 'Mactan (Cebu), The Philippines, 2018',
      zh: 'Mactan (Cebu), The Philippines, 2018',
    },
  },
  {
    author: {
      en: "<strong>Phillips. J. D.</strong>",
      zh: "<strong>Phillips. J. D.</strong>",
    },
    paper: {
      en: "Think for a minute: Cognitive strategies to improve task performance",
      zh: "Think for a minute: Cognitive strategies to improve task performance",
    },
    conference: {
      en: "The 16<sup>th</sup> TEFL International Conference and The 6<sup>th</sup> Hong Kong Association for Applied Linguistics Conference and The 1<sup>st</sup> Macau Association for Applied Linguistics Conference",
      zh: "The 16<sup>th</sup> TEFL International Conference and The 6<sup>th</sup> Hong Kong Association for Applied Linguistics Conference and The 1<sup>st</sup> Macau Association for Applied Linguistics Conference",
    },
    placeAndDate: {
      en: 'Macao SAR, 2018',
      zh: 'Macao SAR, 2018',
    },
  },
  {
    author: {
      en: "<strong>Ren, L.</strong>, Wang, P., Zhao, J., & Chen, P. ",
      zh: "<strong>Ren, L.</strong>, Wang, P., Zhao, J., & Chen, P. ",
    },
    paper: {
      en: "Brand repositioning in the hotel industry - A case study of Howard Johnson in China",
      zh: "Brand repositioning in the hotel industry - A case study of Howard Johnson in China",
    },
    conference: {
      en: "CAUTHE 2018",
      zh: "CAUTHE 2018",
    },
    placeAndDate: {
      en: 'Newcastle, Australia, 2018',
      zh: 'Newcastle, Australia, 2018',
    },
  },
  {
    author: {
      en: "<strong>Wong, U. I. C.</strong>",
      zh: "<strong>Wong, U. I. C.</strong>",
    },
    paper: {
      en: "Get smart: paradoxes and possibilities in tourism, hospitality and events: Religious hospitality management at a Chinese Buddhist site",
      zh: "Get smart: paradoxes and possibilities in tourism, hospitality and events: Religious hospitality management at a Chinese Buddhist site",
    },
    conference: {
      en: "CAUTHE 2018",
      zh: "CAUTHE 2018",
    },
    placeAndDate: {
      en: 'Newcastle, Australia, 2018',
      zh: 'Newcastle, Australia, 2018',
    },
  },
]

export const appendix4 = [
  {
    name: {
      en: "The Institute Scholarship",
      zh: "旅遊學院獎學金",
    },
    count: null,
    bold: true,
  },
  {
    name: {
      en: "Institute Scholarship",
      zh: "旅遊學院獎學金",
    },
    count: 95,
  },
  {
    name: {
      en: "Subsidy for Laptop Purchase",
      zh: "學生購買手提電腦津貼",
    },
    count: 15,
  },
  {
    name: {
      en: "The Most Contribution Scholarship",
      zh: "最具貢獻獎學金",
    },
    count: 1,
  },
  {
    name: {
      en: "Cultural Affairs Bureau Scholarship",
      zh: "文化局獎學金",
    },
    count: null,
    bold: true,
  },
  {
    name: {
      en: "The Best Student of Bachelor of Science in Heritage Management",
      zh: "文化遺產管理學士學位課程最佳學生",
    },
    count: 1,
  },
  {
    name: {
      en: "The Excellent Freshman Students of Bachelor of Science in Heritage Management",
      zh: "文化遺產管理學士學位優異新生",
    },
    count: 3,
  },
  {
    name: {
      en: "Macao Foundation Scholarship",
      zh: "澳門基金會獎學金",
    },
    count: null,
    bold: true,
  },
  {
    name: {
      en: "The Best Student of Bachelor of Science in Tourism Business Management",
      zh: "旅遊企業管理學士學位課程最佳學生",
    },
    count: 1,
  },
  {
    name: {
      en: "The Best Student of Bachelor of Science in Hotel Management",
      zh: "酒店管理學士學位課程最佳學生",
    },
    count: 1,
  },
  {
    name: {
      en: "The Best Student of Bachelor of Science in Hotel Management (Chinese)",
      zh: "酒店管理學士學位課程最佳學生(中文)",
    },
    count: 1,
  },
  {
    name: {
      en: "The Best Student of Bachelor of Science in Hotel Management (Chinese)",
      zh: "酒店管理學士學位課程最佳學生(中文)",
    },
    count: 1,
  },
  {
    name: {
      en: "The Mainland Students with Excellent Academic Performance",
      zh: "最佳學業成績內地學生",
    },
    count: 4,
  },
  {
    name: {
      en: "The Students with International Internship",
      zh: "國際實習生",
    },
    count: 6,
  },
  {
    name: {
      en: "The Students with Excellent Academic Performance",
      zh: "優秀在讀學生",
    },
    count: 12,
  },
  {
    name: {
      en: "The Students with Overseas Exchange Programme",
      zh: "海外交流學習",
    },
    count: 12,
  },
  {
    name: {
      en: "Students from Asian Countries",
      zh: "亞洲學生獎學金",
    },
    count: 2,
  },
  {
    name: {
      en: "Macao Trade and Investment Promotion Institute Scholarship",
      zh: "澳門貿易投資促進局獎學金",
    },
    count: null,
    bold: true,
  },
  {
    name: {
      en: "The Best Student of Bachelor of Science in Tourism Event Management",
      zh: "旅遊會展及節目管理學士學位課程最佳學生",
    },
    count: 1,
  },
  {
    name: {
      en: "Macao Government Tourism Office Scholarship",
      zh: "澳門旅遊局獎學金",
    },
    count: null,
    bold: true,
  },
  {
    name: {
      en: "The Best Student of the Graduating Class",
      zh: "最佳畢業生",
    },
    count: 1,
  },
  {
    name: {
      en: "The Students with Excellent Academic Performance of the Graduating Class of Culinary Arts Management",
      zh: "廚藝管理學士學位課程優秀畢業生",
    },
    count: 3,
  },
  {
    name: {
      en: "Banco Nacional Ultramarino Scholarship",
      zh: "大西洋銀行獎學金",
    },
    count: null,
    bold: true,
  },
  {
    name: {
      en: "The Student with the Best Scholastic Achievement",
      zh: "最佳成績進步學生",
    },
    count: 9,
  },
  {
    name: {
      en: "Best Interns",
      zh: "最佳實習生",
    },
    count: 8,
  },
  {
    name: {
      en: "Conference Grants Group Project Presentation, Conferences",
      zh: "研討會津貼",
    },
    count: 10,
  },
  {
    name: {
      en: "Summer Programmes and Courses",
      zh: "暑期實習計劃及課程",
    },
    count: 5,
  },
  {
    name: {
      en: "Short-term Exchange Trip",
      zh: "短期交流課程",
    },
    count: 7,
  },
  {
    name: {
      en: "Exchange Programme",
      zh: "交換生課程",
    },
    count: 2,
  },
  {
    name: {
      en: "The Students with International Internship",
      zh: "國際實習生",
    },
    count: 1,
  },
  {
    name: {
      en: "Bank of China Scholarship",
      zh: "中國銀行獎學金",
    },
    count: null,
    bold: true,
  },
  {
    name: {
      en: "Overseas Internship",
      zh: "國際實習計劃",
    },
    count: 8,
  },
  {
    name: {
      en: "Summer Programmes and Courses",
      zh: "暑期實習計劃及課程",
    },
    count: 2,
  },
  {
    name: {
      en: "Short-term Exchange Trip",
      zh: "短期交流課程",
    },
    count: 33,
  },
  {
    name: {
      en: "Bank of China 100<sup>th</sup> Anniversary Commemorative Banknote",
      zh: "中國銀行100周年紀念鈔獎",
    },
    count: 24,
    bold: true,
  },
  {
    name: {
      en: "Bank of China Beijing 2008 Olympic Games Commemorative Banknote Award",
      zh: "中國銀行2008北京奧運紀念鈔獎",
    },
    count: 36,
    bold: true,
  },
  {
    name: {
      en: "Cheung Lup Kwan Scholarship",
      zh: "張立群獎學金",
    },
    count: 8,
    bold: true,
  },
  {
    name: {
      en: "Decanter Scholarship",
      zh: "Decanter獎學金",
    },
    count: 2,
    bold: true,
  },
  {
    name: {
      en: "Galaxy Entertainment Group Scholarship",
      zh: "銀河娛樂集團獎學金",
    },
    count: 5,
    bold: true,
  },
  {
    name: {
      en: "Henry Fok Foundation Scholarship",
      zh: "澳門霍英東基金會獎學金",
    },
    count: 8,
    bold: true,
  },
  {
    name: {
      en: "Inspirational Youth Association Scholarship",
      zh: "勵志青年會奬學金",
    },
    count: null,
    bold: true,
  },
  {
    name: {
      en: "Inspirational Youth Scholarship",
      zh: "勵志青年奬學金",
    },
    count: 1,
    bold: false,
  },
  {
    name: {
      en: "Inspirational Youth Fellowship",
      zh: "勵志青年助學金",
    },
    count: 1,
  },
  {
    name: {
      en: "Inspirational Youth Excellence Award",
      zh: "勵志青年飛躍大獎",
    },
    count: 2,
  },
  {
    name: {
      en: "Isabel and Patrick Huen Scholarship",
      zh: "禤永明先生夫人獎學金",
    },
    count: null,
    bold: true,
  },
  {
    name: {
      en: "Overseas Internship",
      zh: "海外實習課程",
    },
    count: 6,
  },
  {
    name: {
      en: "Exchange Programme",
      zh: "交換生課程",
    },
    count: 8,
  },
  {
    name: {
      en: "Conference Grants",
      zh: "研討會津貼",
    },
    count: 1,
  },
  {
    name: {
      en: "Extracurricular Activities",
      zh: "課外活動",
    },
    count: 2,
  },
  {
    name: {
      en: "Master Programme",
      zh: "校友修讀碩士學位課程",
    },
    count: 3,
  },
  {
    name: {
      en: "L’Arc Macau Talent Recognition Programme",
      zh: "澳門凱旋門菁英奬學金",
    },
    count: 3,
    bold: true,
  },
  {
    name: {
      en: "Macau Gaming Equipment Manufacturers Association Scholarship",
      zh: "澳門娛樂設備廠商會奬學金",
    },
    count: 2,
    bold: true,
  },
  {
    name: {
      en: "Macau Hotel Association Scholarship",
      zh: "澳門酒店協會獎學金",
    },
    count: 3,
    bold: true,
  },
  {
    name: {
      en: "Macau Polytex Group Scholarship",
      zh: "保利達集團獎學金",
    },
    count: 10,
    bold: true,
  },
  {
    name: {
      en: "Macau Traveling and Cultural Exchange Promotion Association Scholarship",
      zh: "澳門旅遊文化交流促進會獎學金",
    },
    count: 4,
    bold: true,
  },
  {
    name: {
      en: "Melco Resorts & Entertainment Scholarship",
      zh: "新濠博亞娛樂獎學金",
    },
    count: 3,
    bold: true,
  },
  {
    name: {
      en: "MGM Elite Scholarship",
      zh: "美高梅展才奬學金",
    },
    count: null,
    bold: true,
  },
  {
    name: {
      en: "The Best Students of Bachelor of Science in Tourism Retail and Marketing Management",
      zh: "旅遊零售及市場推廣管理學士學位課程最佳學生",
    },
    count: 2,
  },
  {
    name: {
      en: "The Best Students of Bachelor of Science in Hotel Management",
      zh: "酒店管理學士學位課程最佳學生",
    },
    count: 2,
  },
  {
    name: {
      en: "The Best Students of Bachelor of Science in Tourism Event Management",
      zh: "旅遊會展及節目管理學士學位課程最佳學生",
    },
    count: 1,
  },
  {
    name: {
      en: "The Best Students of Bachelor of Science in Culinary Arts Management",
      zh: "廚藝管理學士學位課程最佳學生",
    },
    count: 2,
  },
  {
    name: {
      en: "The Students with International Internship",
      zh: "國際實習生",
    },
    count: 3,
  },
  {
    name: {
      en: "Nam Kwong Education Scholarship",
      zh: "南光教育獎學金",
    },
    count: 15,
    bold: true,
  },
  {
    name: {
      en: "Sands China Limited Scholarship",
      zh: "金沙中國獎學金",
    },
    count: null,
    bold: true,
  },
  {
    name: {
      en: "Sands China Limited Scholarship",
      zh: "金沙中國獎學金",
    },
    count: 11,
  },
  {
    name: {
      en: "Sands China Limited Fellowship",
      zh: "金沙中國助學金",
    },
    count: 10,
  },
  {
    name: {
      en: "Sheraton Grand Macao Hotel",
      zh: "澳門喜來登大酒店",
    },
    count: 1,
    bold: true,
  },
  {
    name: {
      en: "The St. Regis Macao Hotel Scholarship",
      zh: "澳門瑞吉酒店獎學金",
    },
    count: 1,
    bold: true,
  },
  {
    name: {
      en: "The Golden Burger (Macau) Charity Association Scholarship and Fellowship",
      zh: "澳門金濠漢堡慈善會獎學金及助學金",
    },
    count: 2,
    bold: true,
  },
  {
    name: {
      en: "Wynn Scholarship",
      zh: "永利獎學金",
    },
    count: 12,
    bold: true,
  },
]
